export default __webpack_public_path__ + "static/media/YAS0720.34I-34462_-18867_0.e6806ca5.jpg";